document.querySelectorAll('.MetroStationSelect').forEach((el) => {
    const index = parseInt(el.dataset.metroIndex);
    function get(query) {
        return el.closest('.modal').querySelector(`.MetroLineSelect__item${query}`);
    }

    const triggerEl = get(`[data-metro-target="${index}"]`) || get(`:nth-child(${index+1})`);
    new GroupCheckbox(el, '.MetroStationSelect__list', '.MetroStationSelect__all', triggerEl, (state, {inputs}) => {
        const name = inputs[0] && inputs[0].name;
        if(name) {
            const line = inputs[0].closest('.MetroStationSelect').dataset.metroIndex;
            const filters = getCookieFilters();
            const values = inputs.map((input) => input.value);
            if(state) {
                filters[name] = filters[name].filter((val) => !values.includes(val));
            }
            else {
                filters[name].push(...values);
            }
            if(!filters['line']) filters['line'] = [];
            if(state) {
                if(!filters['line'].includes(line)) {
                    filters['line'].push(line);
                }
            }
            else {
                filters['line'] = filters['line'].filter((val) => val !== line);
            }
            setCookieFilters(filters);
        }
    });
});
